<!--
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: wjx
 * @Date: 2019-03-15 10:04:20
 * @LastEditTime: 2020-11-20 17:26:42
 -->
<template>
  <div class="academy-addedit-wrap">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="160px"
      class="ruleForm"
      :disabled="ifDisable"
    >
      <el-form-item label="资讯标题：" prop="title">
        <el-input
          v-model="ruleForm.title"
          placeholder="请输入资讯标题"
          :maxlength="30"
        ></el-input>
      </el-form-item>
      <el-form-item label="资讯作者：" prop="author">
        <el-input
          v-model="ruleForm.author"
          placeholder="请输入作者"
          :maxlength="10"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否上传视频：" prop="type">
        <el-radio-group v-model="ruleForm.type">
          <el-radio :label="2">是</el-radio>
          <el-radio :label="1">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="视频链接："
        prop="videoUrl"
        v-if="ruleForm.type == 2"
      >
        <el-input
          v-model="ruleForm.videoUrl"
          placeholder="请输入视频链接"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="视频封面图："
        prop="videoPicUrl"
        v-if="ruleForm.type == 2"
      >
        <UploadImgOne
          :initUrl="ruleForm.videoPicUrl"
          @upload-done="waitPicDone2"
        ></UploadImgOne>
      </el-form-item>
      <el-form-item label="正文：" prop="content">
        <Tinymce
          ref="editor"
          v-model="ruleForm.content"
          :height="400"
          :width="'100%'"
          style="max-width:800px;"
        />
      </el-form-item>
      <el-form-item label="封面图：" prop="picUrl">
        <UploadImgOne
          :initUrl="ruleForm.picUrl"
          @upload-done="waitPicDone"
        ></UploadImgOne>
      </el-form-item>
      <el-form-item
        label="订单支付审核："
        v-if="ruleForm.isOrderAudit == 1 && ruleForm.taxCollectionPattern == 4"
      >
        <el-button
          plain
          style="color: #3a8ee6;border-color: #3a8ee6;cursor: default;"
        >
          需审核
        </el-button>
        <span>
          项目支付给自然人时需进行审核
        </span>
      </el-form-item>
      <el-form-item class="button-margin-top">
        <el-button
          type="primary"
          @click="submitForm('ruleForm', 0)"
          :loading="btLoading"
          :disabled="ifDisable"
        >
          保存
        </el-button>
        <!-- <el-button type="primary" @click="db" :loading="btLoading" :disabled="ifDisable">提交</el-button> -->
        <!-- <el-button type="primary" @click="resetForm('ruleForm')">取消</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { btLoading } from '@/Mixin/btLoading';
import { dbCon } from '@/Mixin/doubleConfirm';
import { project, information } from '@/api/ajax';
import dicSelect from '@/components/Common/dicSelect.vue';
import UploadImgOne from '@/components/Common/UploadImgOne.vue';
import { moneyComplete, moneyInt } from '@/tools/money';
import { priceFilter, isInteger } from '@/tools/formCheck';
import htmlEditor from '@/components/135editor.vue';
import Tinymce from '@/components/Tinymce';
export default {
  mixins: [btLoading, dbCon],
  data() {
    return {
      ruleForm: {
        title: '',
        author: '',
        picUrl: '',
        type: 1,
        content: '',
        id: '',
        videoUrl: '',
        videoPicUrl: ''
      },
      // 校验
      rules: {
        title: [
          {
            required: true,
            message: '请填写标题',
            trigger: 'blur'
          }
        ],
        author: [
          {
            required: true,
            message: '请填写作者',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择是否上传视频',
            trigger: 'blur'
          }
        ],
        content: [
          {
            required: true,
            message: '请填写正文',
            trigger: 'blur'
          }
        ],
        picUrl: [
          {
            required: true,
            message: '请上传封面图',
            trigger: 'blur'
          }
        ],
        videoUrl: [
          {
            required: true,
            message: '请填写视频地址',
            trigger: 'blur'
          }
        ],
        videoPicUrl: [
          {
            required: true,
            message: '请上传视频封面图',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  components: {
    dicSelect,
    UploadImgOne,
    htmlEditor,
    Tinymce
  },
  methods: {
    waitPicDone(v) {
      this.ruleForm.picUrl = v;
    },
    waitPicDone2(v) {
      this.ruleForm.videoPicUrl = v;
    },
    getHTMLData(val) {
      this.ruleForm.meetInterlude = val;
    },
    resetForm(formName) {
      this.$router.push({
        path: '/assign/index',
        query: {
          id: this.$route.query.id
        }
      });
    },
    submitForm(formName, type) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 改变按钮状态
          // 混合对象 格式化数据
          information.saveInformation(this.ruleForm).then(res => {
            this.$notify({
              title: '成功',
              message: type === 0 ? '保存成功' : '提交成功',
              type: 'success'
            });
            history.go(-1);
          });
        } else {
          return false;
        }
      });
    }
  },
  computed: {
    ifDisable() {
      return this.ruleForm.projectStatus ? true : false;
    }
  },
  watch: {},
  created() {
    if (this.$route.query.id) {
      information
        .loadInformationVideo({
          id: this.$route.query.id
        })
        .then(res => {
          this.ruleForm = res.data.data;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.button-margin-top {
  margin-top: 77px;

  .el-button {
    border-radius: 2px;
    float: left;

    &:nth-child(n + 2) {
      margin-left: 20px;
    }
  }
}

//中间背景留白 /对照UI
.academy-addedit-wrap {
  height: 100%;
  padding-top: 25px;
  padding-right: 20px;
  background-color: #fff;
  ::v-deep {
    .el-form {
      margin: 0;
    }
  }

  > .el-form {
    height: 100%;
  }

  .el-form-item {
    margin-bottom: 20px;

    .el-input {
      /*输入框宽度*/
      width: 224px;

      &.yuan {
        /*输入框后面追加<元>*/
        &:after {
          content: '元';
          margin-left: 10px;
          position: absolute;
        }
      }
    }

    &.input-width {
      /*项目单价和总任务量输入框宽度*/
      .el-input {
        width: 140px;
      }
    }
  }
}
</style>
